import { Box, Paper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { Page } from 'app/layout/Page';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { customSwitch } from 'utils/customSwitchCase/customSwitch';
import { NotificationDefaultValues } from './Notification/Filters/utils';
import { NotificationMetric } from './Notification/KPIMetric/Tile';
import { TaskDefaultValues } from './Task/Filters/utils';
import Timeframe from './Timeframe/Timeframe';
import _ from 'lodash';
import { GenericTabs } from '@AMIEWEB/Common/Tabs/GenericTabs';
import { ReportPage, TabTitle } from './PerformanceReport';

const useStyles = makeStyles()((theme, props) => ({
  root: {
    minHeight: 'calc(100vh - 105px)',
    padding: 15,
  },
}));

export const ReportPageWrapper = () => {
  const { t } = useTranslation();
  const { classes, cx } = useStyles();

  const [displayTab, setDisplayTab] = useState<TabTitle>(TabTitle.communication);

  const getDefaultFilter = customSwitch({
    [TabTitle.communication]: NotificationDefaultValues,
    [TabTitle.task]: TaskDefaultValues,
  })(null);

  //Timeframe
  const [selectedRange, setSelectedRange] = useState<{ startDate: Date | string; endDate: Date | string }>({
    startDate: new Date(),
    endDate: new Date(),
  });
  const [selectKpiFilter, setSelectKpiFilter] = useState<any>(getDefaultFilter(displayTab));
  const [selectedKpiMetric, setSelectedKpiMetric] = useState<string>(NotificationMetric.CallOut);

  const handleTabChange = (tab: TabTitle) => {
    setSelectKpiFilter(getDefaultFilter(tab));
    if (tab === 0) {
      setSelectedKpiMetric(NotificationMetric.CallOut);
    }
    setDisplayTab(tab);
  };

  const reportPage = useMemo(() => {
    return (
      <ReportPage
        displayTab={displayTab}
        selectedRange={selectedRange}
        selectKpiFilter={selectKpiFilter}
        setSelectKpiFilter={setSelectKpiFilter}
        selectedKpiMetric={selectedKpiMetric}
        setSelectedKpiMetric={setSelectedKpiMetric}
      />
    );
  }, [displayTab, selectedRange, selectKpiFilter, selectedKpiMetric]);

  return (
    <Page>
      <LayoutGrid direction="column">
        <LayoutGridItem>
          <LayoutGridItem>{<Box className="reports-title">{`Reports`}</Box>}</LayoutGridItem>
        </LayoutGridItem>
        <LayoutGridItem xs={12} sx={{ width: '100%' }}>
          <Paper id="reports-page-paper" className={cx('paper-2 layout')} classes={{ root: classes.root }}>
            <Timeframe
              onDateChange={(range: { startDate: Date; endDate: Date }) => {
                setSelectedRange({
                  startDate: range.startDate,
                  endDate: range.endDate,
                });
              }}
            />
            <Box style={{ borderBottom: 1, borderColor: 'divider' }}>
              <GenericTabs
                tabs={[
                  {
                    label: t('notification.reports.communicationHeader'),
                    component: reportPage,
                  },
                  {
                    label: t('notification.reports.tasks'),
                    component: reportPage,
                  },
                ]}
                value={displayTab}
                onTabChanged={handleTabChange}
                analytics={{ name: 'Performance Report' }}
              />
            </Box>
          </Paper>
        </LayoutGridItem>
      </LayoutGrid>
    </Page>
  );
};
